import DisplayData from 'portaltransparencia-common/components/displaydata/DisplayData.react.js';
import DisplayDataItem from 'portaltransparencia-common/components/displaydata/DisplayDataItem.react.js';
import DisplayDataRow from 'portaltransparencia-common/components/displaydata/DisplayDataRow.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import SearchPagination from 'portaltransparencia-common/components/SearchPagination.react.js';
import TableActions from 'portaltransparencia-common/components/TableActions.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import TableHeaderItem from 'portaltransparencia-common/components/TableHeaderItem.react';
import Widget from 'portaltransparencia-common/components/Widget.react.js';
import {
  addFilterUrl,
  addPagination
} from 'portaltransparencia-common/libs/AddFilter.js';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import NumberUtils from 'portaltransparencia-common/libs/NumberUtils.js';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';

import PageHeader from '../components/PageHeader.react.js';
import NotasExplicativas from '../notaexplicativa/Form.react.js';
import UltimaAtualizacao from '../ultimaatualizacao/Form.react.js';
import {
  findDiariosOficiais,
  onChangeFilter,
  onClearFilter
} from './ActionsDiario.js';
import DiarioFiltro from './DiarioFiltro.react.js';

export class FormDiario extends React.Component {
  static propTypes = {
    onChangeFilter: PropTypes.func.isRequired,
    onClearFilter: PropTypes.func.isRequired,
    findDiariosOficiais: PropTypes.func.isRequired,
    diarios: PropTypes.array.isRequired,
    filter: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired
  };

  searchWithPage = page => {
    const { findDiariosOficiais } = this.props;

    const filterQuery = this.montaFilter(page);
    findDiariosOficiais(filterQuery);
  };

  base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  onConsultar = () => {
    const { findDiariosOficiais, diarios } = this.props;

    const filterQuery = this.montaFilter(diarios);
    findDiariosOficiais(filterQuery);
  };

  montaFilter = page => {
    const { filter } = this.props;
    let filterQuery = '?';

    if (filter.mesPublicacao) {
      filterQuery = addFilterUrl(
        filterQuery,
        `mesPublicacao=${filter.mesPublicacao}`
      );
    }

    if (filter.anoPublicacao) {
      filterQuery = addFilterUrl(
        filterQuery,
        `anoPublicacao=${filter.anoPublicacao}`
      );
    }

    if (filter.numero) {
      filterQuery = addFilterUrl(filterQuery, `numero=${filter.numero}`);
    }

    if (filter.chave) {
      filterQuery = addFilterUrl(filterQuery, `palavraChave=${filter.chave}`);
    }

    if (filter.dataInicio) {
      filterQuery = addFilterUrl(
        filterQuery,
        `dataInicio=${filter.dataInicio}`
      );
    }

    if (filter.dataFim) {
      filterQuery = addFilterUrl(filterQuery, `dataFim=${filter.dataFim}`);
    }

    return addPagination(page, filterQuery);
  };

  generateBlob(byte) {
    return new Blob([byte], { type: 'application/pdf' });
  }

  onDownloadDiarioUltimaPublicacao = () => {
    const { diarios } = this.props;

    this.onDownloadDiario(diarios.get('content').get(0));
  };

  onVisualizarDiarioUltimaPublicacao = () => {
    const { diarios } = this.props;

    this.onVisualizarDiario(diarios.get('content').get(0));
  };

  onDownloadDiario = diarioOficial => {
    const sampleArr = this.base64ToArrayBuffer(diarioOficial.get('arquivo'));
    const blob = this.generateBlob(sampleArr);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);

    const fileName = `Diário oficial: ${diarioOficial.get(
      'numero'
    )}_${diarioOficial.get('ano')}_${diarioOficial.get('descricaoTipo')}`;

    link.download = fileName;
    link.click();
  };

  onVisualizarDiario = diarioOficial => {
    const sampleArr = this.base64ToArrayBuffer(diarioOficial.get('arquivo'));
    const blob = this.generateBlob(sampleArr);
    window.open(window.URL.createObjectURL(blob), '_blank');
  };

  renderDiarioOficial = diarioOficial => (
    <TableActions
      showView
      key={diarioOficial.id}
      data={diarioOficial}
      onDownload={this.onDownloadDiario}
      onView={this.onVisualizarDiario}
    >
      <td>{diarioOficial.get('numero')}</td>
      <td>{diarioOficial.get('descricaoTipo')}</td>
      <td>{diarioOficial.get('descricao')}</td>
      <td>
        {DateUtils.formatDateTimeShort(diarioOficial.get('dataPublicacao'))}
      </td>
      <td>{diarioOficial.get('usuarioPublicacao')}</td>
      <td>{diarioOficial.get('usuarioResponsavel')}</td>
      <td>{NumberUtils.formatBytes(diarioOficial.get('tamanhoArquivo'))}</td>
    </TableActions>
  );

  render() {
    const { diarios, onChangeFilter, filter, onClearFilter } = this.props;

    return (
      <section>
        <PageHeader location={this.props.location} />
        <NotasExplicativas pathname={this.props.location.pathname} />
        <DiarioFiltro
          show
          findDiarios={this.onConsultar}
          onChangeFilter={onChangeFilter}
          onClearFilter={onClearFilter}
          filter={filter}
        />
        {diarios.get('content') && diarios.get('content').length > 0 && (
          <Widget icon="fa fa-newspaper-o" title={'Última publicação'}>
            <DisplayData border>
              <DisplayDataRow>
                <DisplayDataItem
                  sm={2}
                  title="Edição"
                  value={diarios.get('content').get(0).get('numero')}
                />
                <DisplayDataItem
                  sm={3}
                  title="Tipo"
                  value={diarios.get('content').get(0).get('descricaoTipo')}
                />
                <DisplayDataItem
                  sm={3}
                  title="Tamanho arquivo"
                  value={NumberUtils.formatBytes(
                    diarios.get('content').get(0).get('tamanhoArquivo')
                  )}
                />
                <DisplayDataItem
                  sm={4}
                  title="Data publicação"
                  value={DateUtils.formatDateTimeShort(
                    diarios.get('content').get(0).get('dataPublicacao')
                  )}
                />
              </DisplayDataRow>
              <DisplayDataRow>
                <DisplayDataItem
                  sm={12}
                  title="Descrição"
                  value={diarios.get('content').get(0).get('descricao')}
                />
              </DisplayDataRow>
              <DisplayDataRow>
                <DisplayDataItem
                  sm={6}
                  title="Usuário responsável"
                  value={diarios
                    .get('content')
                    .get(0)
                    .get('usuarioResponsavel')}
                />
                <DisplayDataItem
                  sm={6}
                  title="Usuário Publicação"
                  value={diarios.get('content').get(0).get('usuarioPublicacao')}
                />
              </DisplayDataRow>
            </DisplayData>
            <div className="center mt-xs">
              <button
                type="button"
                className="btn inline"
                onClick={this.onDownloadDiarioUltimaPublicacao}
                title={'Download'}
              >
                Download
              </button>
              <button
                type="button"
                className="btn inline"
                onClick={this.onVisualizarDiarioUltimaPublicacao}
                title={'Visualizar'}
              >
                Visualizar
              </button>
            </div>
          </Widget>
        )}
        <Panel isForm tableResponsive expansible={false}>
          <Row>
            <Col xs={6}>
              <UltimaAtualizacao modulo="19" />
            </Col>
          </Row>

          <div className="panel-table-outer">
            <table className="panel-table striped fancy">
              <TableHeader
                empty={
                  !diarios.get('content') || diarios.get('content').isEmpty()
                }
              >
                <tr>
                  <TableHeaderItem
                    field="numero"
                    label="Edição"
                    page={diarios}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="descricaoTipo"
                    label="Tipo"
                    page={diarios}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="descricao"
                    label="Descrição"
                    page={diarios}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="dataPublicacao"
                    label="Data publicação"
                    page={diarios}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="usuarioPublicacao"
                    label="Usuário publicação"
                    page={diarios}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="usuarioResponsavel"
                    label="Responsavel"
                    page={diarios}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="tamanhoArquivo"
                    label="Tamanho arquivo"
                    page={diarios}
                    searchWithPage={this.searchWithPage}
                  />
                  <th></th>
                </tr>
              </TableHeader>
              <tbody>
                {diarios.get('content') &&
                  diarios
                    .get('content')
                    .map(diarioOficial =>
                      this.renderDiarioOficial(diarioOficial)
                    )
                    .toArray()}
              </tbody>
            </table>
          </div>
          <SearchPagination
            page={diarios}
            searchWithPage={this.searchWithPage}
          />
        </Panel>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    diarios: state.diarioReducer.get('diarios'),
    filter: {
      chave: state.diarioReducer.get('chave'),
      mesPublicacao: state.diarioReducer.get('mesPublicacao'),
      anoPublicacao: state.diarioReducer.get('anoPublicacao'),
      numero: state.diarioReducer.get('numero'),
      dataInicio: state.diarioReducer.get('dataInicio'),
      dataFim: state.diarioReducer.get('dataFim')
    }
  };
}

const allActions = { findDiariosOficiais, onChangeFilter, onClearFilter };

export default connect(mapStateToProps, allActions)(FormDiario);
